module.exports = __webpack_public_path__ + "img/t_0023.949a154b.gif";